import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { Toast } from "azure-devops-ui/Toast";

interface IToastExampleState {
    isToastVisible: boolean;
    isToastFadingOut: boolean;
}

export default class ToastExample extends React.Component<{}, IToastExampleState> {
    private toastRef: React.RefObject<Toast> = React.createRef<Toast>();

    constructor() {
        super({});

        this.state = {
            isToastVisible: false,
            isToastFadingOut: false
        };
    }

    public render() {
        const { isToastVisible, isToastFadingOut } = this.state;
        return (
            <div className="flex-column">
                <Button
                    text={isToastVisible ? "Hide toast" : "Display toast"}
                    onClick={this.onButtonClick}
                    disabled={isToastFadingOut}
                />
                {isToastVisible && (
                    <Toast
                        ref={this.toastRef}
                        message="I'm a toast!"
                        callToAction="Click me"
                        onCallToActionClick={() => alert("Call to action onClick")}
                    />
                )}
            </div>
        );
    }

    private onButtonClick = () => {
        if (this.state.isToastFadingOut) {
            return;
        }

        if (this.state.isToastVisible && this.toastRef.current) {
            this.setState({ isToastFadingOut: true });
            this.toastRef.current.fadeOut().promise.then(() => {
                this.setState({ isToastVisible: false, isToastFadingOut: false });
            });
        } else {
            this.setState({ isToastVisible: true });
        }
    };
}
